export const RESPONSE_STATUS = {
  BadRequest: {
    statusCode: 400,
    statusMessage: "Bad Request",
  },
  Unauthenticated: {
    statusCode: 401,
    statusMessage: "Unauthenticated",
  },
  Forbidden: {
    statusCode: 403,
    statusMessage: "Access is forbidden",
  },
  NotFound: {
    statusCode: 404,
    statusMessage: "Page not found",
  },
  Unprocessable: {
    statusCode: 422,
    statusMessage: "Validation error occurred",
  },
  TooManyRequests: {
    statusCode: 429,
    statusMessage: "Too many requests",
  },
  ServerError: {
    statusCode: 500,
    statusMessage: "Internal Server Error",
  },
} as const;
